import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';

const initialState = fromJS({
    list: {
        isLoading: false,
        data: null
    },
    types: {
        isLoading: false,
        data: null
    },
    selectedSwitch: -7
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // switches
        case CONSTANTS.ON_SELECT_SWITCH:
            return state.set('selectedSwitch', payload.swId);

        case CONSTANTS.ON_SWITCH_LIST_IS_LOADING:
            return state.setIn(['list', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_SWITCH_LIST:
            return state.setIn(['list', 'data'], payload.data)
                .set('selectedSwitch', -7);

        case CONSTANTS.ON_RELAY_TYPES_IS_LOADING:
            return state.setIn(['types', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_RELAY_TYPES:
            return state.setIn(['types', 'data'], payload.data)
                .set('selectedSwitch', -7);

        default:
            return state;
    }
};

export default reducer;
